import { sparklinePoints } from '@/app/lib/quant/sparkline'
import type { Run } from '@/app/lib/quant/types'
import { returnTone, type ReturnTone } from '@/ui/lib/quantFormat'
import { QuantSparkline } from '@/ui/QuantSparkline'

/** A run's equity sparkline: a run with no equity series reserves the same empty cell. */
export function QuantRunSparkline({ run, width, height }: { run: Run; width: number; height: number }) {
  const values = run.equity_sparkline
  const { points, baselineY } = sparklinePoints(values, width, height, 1)
  let tone: ReturnTone = 'none'
  if (values && points.length > 0) {
    const shown = values.slice(0, points.length)
    tone = returnTone(run.return_pct ?? ((shown[shown.length - 1] - shown[0]) / (shown[0] || 1)) * 100)
  }
  return <QuantSparkline points={points} baselineY={baselineY} width={width} height={height} tone={tone} />
}
